// sekcie_v1 (20. 10. 2026, 0.J): DetailRow je jeden, v components/Ui.jsx
// vzhlad_predajne_v2 (20. 10. 2026, ústava 61.10): starý oranžový panel/akcent nahradený hodnotami témy — 4 miest
// build: objednavka-novyzak-v2 2026-06-25
// ╔══════════════════════════════════════════════════════════════════╗
// ║  _ModuleTemplate.jsx — REFERENČNÁ ŠABLÓNA MODULU MATRIX v2        ║
// ║  Ústava 9.D.1 bod 2 — anti-chyba systém.                          ║
// ╠══════════════════════════════════════════════════════════════════╣
// ║  NOVÝ MODUL VZNIKÁ KÓPIOU TOHTO SÚBORU — NIKDY NIE OD NULY.       ║
// ║  Tým sa ústavné systémové veci NEDAJÚ vynechať.                   ║
// ║                                                                  ║
// ║  POSTUP (ústava 9.D.1):                                          ║
// ║   1. PRE-FLIGHT dokument — schváli Mirko PRED prvým riadkom.      ║
// ║   2. cp _ModuleTemplate.jsx → views/MojModul.jsx                 ║
// ║   3. Vyplň CFG · EDIT_FIELDS · STATUS_FILTERS · polia formulára.  ║
// ║   4. Nahraď TODO značky. Skontroluj DoD checklist (dole).         ║
// ╠══════════════════════════════════════════════════════════════════╣
// ║  ČO JE V ŠABLÓNE ZABUDOVANÉ (ústavné systémové veci):            ║
// ║   • master-detail layout ......................... sek. 56       ║
// ║   • LOCK multi-user (cez useRecordEditor) ........ sek. 53.7      ║
// ║   • DIRTY dialóg pri odchode ..................... sek. 53.1      ║
// ║   • Form → Confirm + DIFF pred uložením .......... 12.0/3 · 53.8  ║
// ║   • audit kto/čo/kedy (HistoryPanel + auto-log) .. 12.0/1         ║
// ║   • fulltext hľadanie v zozname .................. sek. 56        ║
// ║   • SearchableSelect (žiadny plain <select>) ..... sek. 56.11     ║
// ║   • TINT pozadia (žiadne inline farby) ........... sek. 21.15     ║
// ║   • dedup kontrola (409 z backendu) .............. sek. 13        ║
// ║   • klávesnica (mod+N, /) + cheatsheet ........... sek. 54        ║
// ║   • breadcrumb — rieši Layout .................... sek. 53.2      ║
// ╚══════════════════════════════════════════════════════════════════╝

import { setDirty as setGuardDirty, confirmLeave, pripravDokument } from '../hooks/unsavedGuard.js'   // p95 — doklad = obrazovka (ústava 67.15)
import { KontaktnaOsoba } from '../components/KontaktyPartnera.jsx'   // ústava 131.10 + 0.J — jeden blok kontaktnej osoby (p93)
import React, { useState, useMemo, useEffect, useCallback, useRef } from 'react'
import TelefonInput from '../components/TelefonInput.jsx'
import useLiveRefresh from '../hooks/useLiveRefresh.js'
import { COLORS, TYPO, SPACE, RADIUS, TINT, SK, todayLocal, norm, hladaj } from '../theme.js'
import {
  PageHeader, MasterDetail, SearchInput, ListRow, ListStatusBar,
  FilterChips, KpiRow, KpiCard, Tabs, EmptyPane, SearchableSelect, DetailRow } from '../components/Ui.jsx'
import { Modal } from '../components/Modal.jsx'
import SendCustomerDialog from '../components/SendCustomerDialog.jsx'
import { Btn, BtnAdd, BtnGhost } from '../components/Btn.jsx'
import { HistoryPanel } from '../components/HistoryPanel.jsx'
import HelpHint from '../components/HelpHint.jsx'
import { useToast } from '../components/Toast.jsx'
import { useShortcuts } from '../hooks/useShortcuts.js'
import { useRecordEditor } from '../hooks/useRecordEditor.js'
import NoviCustomerDialog from '../components/NoviCustomerDialog.jsx'
import { normPhone } from '../utils/phone.js'
import { useListKeyboard } from '../hooks/useListKeyboard.js'
import { usePositionMemory } from '../hooks/usePositionMemory.js'
import { useAuth } from '../auth/AuthContext.jsx'
import { fetchAuth } from '../auth/fetchAuth.js'
import RowMenu from '../components/RowMenu.jsx'
import { useConfirm } from '../components/ConfirmDialog.jsx'
import ExportMenu from '../components/ExportMenu.jsx'
import useOtvorZOdkazu, { odkazZAdresy, najnovsiaVerzia } from '../hooks/useOtvorZOdkazu.js'   // CP_OTVOR_V1: /objednavky?open=<id> otvorí práve tú objednávku

// ╔═══ KONFIGURÁCIA MODULU — VYPLŇ PRI KOPÍROVANÍ ═══════════════════╗
// DÔLEŽITÉ: resource MUSÍ byť presne cesta API segmentu (napr. 'work-schedule'
// pre /api/work-schedule). Server zapisuje audit pod týmto názvom — ak sa
// nezhoduje, HistoryPanel nenájde históriu (ústava-review 9.D.3).
const CFG = {
  resource:    'orders',
  apiBase:     '/api/orders',
  titlePlural: 'Objednávky',
  newLabel:    'Nová objednávka',
}

// Polia pre DIFF (ústava 53.8) — useRecordEditor ich porovná initial vs. zmenené.
// label = ako sa pole volá v Confirm prehľade. format = voliteľné zobrazenie.
const EDIT_FIELDS = [
  { name: 'order_number', label: 'Číslo OBJ' },
  { name: 'type',         label: 'Typ' },
  { name: 'status',       label: 'Stav' },
  { name: 'partner_id',   label: 'Partner' },
  { name: 'project_id',   label: 'Zákazka' },
  { name: 'notes',        label: 'Poznámka' },
]

// Filter chips (ústava 21.15 — farby gest). key 'all' = bez filtra.
const STATUS_FILTERS = [
  { key: 'all',       label: 'Všetko',    color: COLORS.muted },
  { key: 'draft',     label: 'Pracovné',  color: COLORS.muted },
  { key: 'sent',      label: 'Odoslané',  color: COLORS.nav },
  { key: 'confirmed', label: 'Potvrdené', color: COLORS.add },
  { key: 'cancelled', label: 'Zrušené',   color: COLORS.remove },
]
const STATUS_LABEL = {
  rozpracovana: 'Pracovná',   // cp_obj_sto_v1: stav, ktorý sem zapisoval server; 1 objednávka v ňom visí bez štítku
  draft:     'Pracovná',
  sent:      'Odoslaná',
  confirmed: 'Potvrdená',
  cancelled: 'Zrušená',
}

// ══════════════════════════════════════════════════════════════════
// HLAVNÝ KOMPONENT — master-detail stránka (ústava sek. 56)
// ══════════════════════════════════════════════════════════════════
export default function ModuleTemplate() {
  const { user } = useAuth()                 // user pre LOCK (53.7)
  const toast = useToast()
  const confirm = useConfirm()

  // ── pamäť pozície (ústava 53.3) — obnoví výber / filter / hľadanie / scroll ──
  const pos = usePositionMemory(CFG.resource)
  const listRef = useRef(null)

  const [rows, setRows]       = useState([])
  const [customers, setCustomersList] = useState([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch]   = useState(pos.filter?.search || '')
  const [filter, setFilter]   = useState(pos.filter?.status || 'all')
  const [selectedId, setSelectedId] = useState(() => odkazZAdresy() || pos.selectedRow || null)   // CP_OTVOR_V1: odkaz pred pamäťou pozície
  const [modal, setModal]     = useState(null)  // null | {record} | {record:null}

  // ── Odoslanie OBJ e-mailom z Matrixu (náhľad pred odoslaním, ústava 67.14 + 531) ──
  const [mailFor, setMailFor] = useState(null)
  const [mailData, setMailData] = useState({ to: '', subject: '', text: '', sending: false })
  const openSendMail = async (row) => {
    if (!(await pripravDokument(toast))) return   // p95: najprv uložiť, až potom okno odoslania (ústava 67.15)
    const cust = customers.find(c => c.id === row.partner_id)
    const ver = Number(row.doc_version || 1)
    const num = row.order_number || row.id
    const custPhone = (cust && (cust.phone || cust.contact)) || row.contact_phone || ''
    setMailData({
      to: (cust && cust.email) || row.contact_email || '',
      phone: normPhone(custPhone),
      sms: !!custPhone,
      subject: `Objednávka ${num}` + (ver > 1 ? ' — aktualizácia' : ''),
      text: `Dobrý deň,\n\nv prílohe Vám posielame objednávku č. ${num}${row.stavba ? ' — ' + row.stavba : ''}${ver > 1 ? ' (aktualizované znenie — nahrádza predchádzajúcu verziu)' : ''}.\n\nV prípade otázok nás neváhajte kontaktovať.\n\nS pozdravom,\nKAMIR s.r.o.`,
      sending: false,
    })
    setMailFor(row)
  }
  const doSendMail = async () => {
    setMailData(m => ({ ...m, sending: true }))
    try {
      const r = await fetchAuth(`/api/orders/${mailFor.id}/send-email`, { method: 'POST', body: JSON.stringify({ email: mailData.to, subject: mailData.subject, text: mailData.text }) })
      const d = await r.json(); if (!r.ok) throw new Error(d.error || 'Odoslanie zlyhalo')
      toast.success('Odoslané na ' + d.to + ' — OBJ je odteraz uzamknutá (úprava cez Aktualizovať).')
      // informatívna SMS zákazníkovi (rovnako ako CP, Mirko 22.7.): „bola Vám odoslaná objednávka"
      if (mailData.sms && mailData.phone) {
        try {
          const sr = await fetchAuth('/api/sms/send', { method: 'POST', body: JSON.stringify({ to: mailData.phone, text: 'Dobry den, prave sme Vam poslali objednavku ' + (mailFor.order_number || mailFor.id) + ' na email. V pripade otazok volajte 0918 443 675. KAMIR', entity_type: mailFor.project_id ? 'project' : '', entity_id: mailFor.project_id || '' }) })
          const sd = await sr.json().catch(() => ({}))
          if (sr.ok && sd.ok) toast.success('Informatívna SMS odoslaná na ' + mailData.phone)
          else toast.error('SMS sa neodoslala: ' + (sd.error || 'chyba brány'))
        } catch (_) { toast.error('SMS sa neodoslala.') }
      }
      setMailFor(null); load()
    } catch (e) { toast.error(e.message); setMailData(m => ({ ...m, sending: false })) }
  }

  // ── načítanie dát ────────────────────────────────────────────────
  // obj_blik_v2 (Mirko 6. 10. 2026 „stĺpec ľavý preblikuje“): ticho=true → zoznam sa obnoví na pozadí a NEPREPNE
  // sa na „Načítavam…“. Živé obnovenie po cudzej zmene (SSE) je vždy tiché; hláška ostáva len pri prvom otvorení.
  const load = useCallback(async (ticho = false) => {
    if (!ticho) setLoading(true)
    try {
      fetchAuth('/api/customers').then(r => r.ok ? r.json() : []).then(d => setCustomersList(Array.isArray(d) ? d : []))
      const r = await fetchAuth(CFG.apiBase)
      const d = await r.json()
      setRows(Array.isArray(d) ? d : (d.rows || []))
    } catch (_) {
      toast.error('Dáta sa nenačítali.')
    } finally {
      setLoading(false)
    }
  }, [toast])

  useEffect(() => { load() }, [load])
  useLiveRefresh(() => load(true))  // živé obnovenie (SSE, ústava 97) — obj_blik_v2: ticho, bez preblikania

  // ── filter + fulltext hľadanie (ústava sek. 56) ──────────────────
  // ROZDELENIE DOŠLÉ / VYSTAVENÉ (Mirko 27.7. „mali byť už dávno rozdelené"; ústava 5697:
  // VYSTAVENÁ type='sent' = my objednávame u dodávateľa; DOŠLÁ type='received' = zákazník objednal u nás).
  // Staré záznamy bez typu = 'sent' (default z createNewOrder).
  const [typeTab, setTypeTab] = useState('sent')
  const filtered = useMemo(() => {
    const q = norm(search.trim())   // V3: bez diakritiky (66.1)
    return rows.filter(row => {
      if (row.replaced_by) return false  // staré verzie skryť — viditeľná len najnovšia (ústava 67.14)
      if ((row.type === 'received' ? 'received' : 'sent') !== typeTab) return false
      if (filter !== 'all' && row.status !== filter) return false
      if (!q) return true
      // hľadá vo všetkých textových poliach záznamu
      return Object.values(row).some(v =>
        v != null && norm(v).includes(q))
    })
  }, [rows, search, filter, typeTab])
  // V3 P1 (N01): jedno poradie pre zoznam aj šípky.
  // obj_poradie_v1 (Mirko 6. 10. 2026: „prečo nejdu najnovšie hore???“): NAJNOVŠIE HORE — dovtedy bol zoznam
  // abecedne podľa partnera a dnešná objednávka skončila uprostred. Rozhoduje dátum vystavenia, pri zhode čas
  // vytvorenia, až nakoniec meno partnera (aby bolo poradie jednoznačné aj bez dátumov).
  const listRows = useMemo(() => {
    const customerMap = {}
    customers.forEach(c => { customerMap[c.id] = c.name })
    const enriched = filtered.map(r => ({ ...r, _zakaznikMeno: r.partner_name || customerMap[r.customerId] || customerMap[r.partner_id] || '— bez zákazníka —' }))
    const kedy = r => String(r.date_issued || '') + ' ' + String(r.created_at || '')
    return [...enriched].sort((a, b) => {
      const d = kedy(b).localeCompare(kedy(a))          // zostupne: najnovšie hore
      if (d !== 0) return d
      return String(a._zakaznikMeno).localeCompare(String(b._zakaznikMeno), 'sk', { sensitivity: 'base' })
    })
  }, [filtered, customers])

  const selected = useMemo(
    () => rows.find(r => r.id === selectedId) || null,
    [rows, selectedId])

  // CP_OTVOR_V1 (Mirko 22. 10. 2026): CP → Vystaviť objednávku posiela /objednavky?open=<id>. Bez čísla sa otvorila
  // naposledy vybraná objednávka z pamäte pozície. Odkaz prepne aj záložku Vystavené/Došlé, keď je objednávka v druhej.
  useOtvorZOdkazu({
    rows, loading,
    najdi: (s) => najnovsiaVerzia(rows, rows.find(r => r.id === s) || rows.find(r => r.order_number === s && !r.replaced_by) || null),
    viditelny: (row) => filtered.some(r => r.id === row.id),
    vyber: setSelectedId,
    zrusFilter: (row) => { setTypeTab(row.type === 'received' ? 'received' : 'sent'); setFilter('all'); setSearch('') },
  })

  // ── pamäť pozície — zápis zmien (ústava 53.3) ────────────────────
  useEffect(() => { pos.selectRow(selectedId) }, [selectedId, pos.selectRow])
  useEffect(() => { pos.setFilter({ status: filter, search }) }, [filter, search, pos.setFilter])
  useEffect(() => {
    if (!loading && listRef.current) pos.restoreScroll(listRef.current)
  }, [loading])  // eslint-disable-line react-hooks/exhaustive-deps

  // ── klávesová navigácia zoznamu (ústava 54.2, 56.5) — zdieľaný hook ──
  const openRecord = useCallback((row) => setModal({ record: row }), [])
  // Nová objednávka BEZ modalu (Mirko 2026-06-25): vytvor prázdnu → vyber → otvorí sa pravý editor
  const createNewOrder = useCallback(async () => {
    try {
      const r = await fetchAuth(CFG.apiBase, { method: 'POST', body: JSON.stringify({ type: typeTab, status: 'draft' }) })
      if (!r.ok) { toast.error('Vytvorenie zlyhalo.'); return }
      const created = await r.json()
      await load()
      setSelectedId(created.id)
      toast.success((typeTab === 'received' ? 'Nová DOŠLÁ objednávka' : 'Nová VYSTAVENÁ objednávka') + ' — vyplň údaje vpravo.')
    } catch (e) { toast.error('Chyba: ' + e.message) }
  }, [load, toast, typeTab])
  useListKeyboard({
    items: listRows,   // V3 P1 (N01)
    selectedId,
    onSelect: (id) => confirmLeave().then(ok => ok && setSelectedId(id)),
    onOpen: openRecord,
    enabled: !modal,
  })

  // ── klávesové skratky (ústava sek. 54) ───────────────────────────
  useShortcuts([
    { keys: 'alt+n', label: CFG.newLabel, scope: CFG.resource,
      handler: () => createNewOrder() },
    { keys: '/', label: 'Hľadať', scope: CFG.resource, handler: () => {
      const el = document.querySelector(`[data-${CFG.resource}-search]`)
      if (el) el.focus()
    } },
  ])

  // ── KPI súhrn (ústava sek. 56.8) ─────────────────────────────────
  const kpi = useMemo(() => {
    const base = rows.filter(r => !r.replaced_by && (r.type === 'received' ? 'received' : 'sent') === typeTab)
    return { total: base.length, active: base.filter(r => r.status === 'active').length }
  }, [rows, typeTab])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <PageHeader title={CFG.titlePlural} subtitle={`${filtered.length} z ${rows.length}`}>
        <ExportMenu
          data={filtered}
          filename={`objednavky-${todayLocal()}`}
          title="Objednávky"
          columns={[
            // drobne_v1 (nočný čitateľ): tabuľka orders nemá „name", „customer_name" ani „amount_total" —
            // export mal tri prázdne stĺpce. Berieme to, čo tam naozaj je.
            { key: 'order_number',   label: 'Číslo OBJ' },
            { key: 'stavba',         label: 'Stavba' },
            { key: 'contact_person', label: 'Kontaktná osoba' },
            { key: 'date_issued',    label: 'Dátum' },
            { key: 'date_delivery',  label: 'Dodanie' },
            { key: 'status',         label: 'Stav' },
          ]}
        />
        <BtnAdd onClick={createNewOrder}>+ {typeTab === 'received' ? 'Nová došlá' : 'Nová vystavená'}</BtnAdd>
      </PageHeader>

      <Tabs value={typeTab} onChange={t => confirmLeave().then(ok => { if (ok) { setTypeTab(t); setSelectedId(null) } })} tabs={[
        { key: 'sent',     label: 'Vystavené — my objednávame' },
        { key: 'received', label: 'Došlé — nám objednali' },
      ]} />

      <KpiRow cols={2}>
        <KpiCard title="Spolu" color={COLORS.nav} value={kpi.total} />
        <KpiCard title="Aktívne" color={COLORS.add} value={kpi.active} />
      </KpiRow>

      <div style={{ height: SPACE.md }} />

      <MasterDetail
        left={
          <>
            <SearchInput value={search} onChange={setSearch}
              dataAttr={`data-${CFG.resource}-search`}
              placeholder="Hľadať (stlač /)…" />
            <FilterChips options={STATUS_FILTERS} value={filter} onChange={setFilter} />
            <div ref={listRef}
              onScroll={e => pos.saveScroll(e.currentTarget.scrollLeft, e.currentTarget.scrollTop)}
              style={{ flex: 1, overflow: 'auto', padding: 6 }}>
              {loading ? (
                <div style={{ padding: SPACE.lg, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>
                  Načítavam…
                </div>
              ) : filtered.length === 0 ? (
                <div style={{ padding: SPACE.lg, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>
                  Žiadne záznamy.
                </div>
              ) : (() => {
                const customerMap = {}
                customers.forEach(c => { customerMap[c.id] = c.name })
                // meno zo servera (getOrderWithPartner → partner_name) je vždy aktuálne; customerMap len fallback (Mirko 22.7.)
                const enriched = filtered.map(r => ({ ...r, _zakaznikMeno: r.partner_name || customerMap[r.customerId] || customerMap[r.partner_id] || '— bez zákazníka —' }))
                const sorted = listRows   // V3 P1 (N01): to isté poradie ako šípky
                return sorted.map(row => (
                <ListRow key={row.id}
                  dataId={row.id}
                  selected={row.id === selectedId}
                  onClick={() => confirmLeave().then(ok => ok && setSelectedId(row.id))}
                  onDoubleClick={() => setModal({ record: row })}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 6 }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: TYPO.weights.semibold, color: COLORS.text,
                        whiteSpace: 'normal', wordBreak: 'break-word' }}>
                        {row._zakaznikMeno}
                      </div>
                      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontFamily: TYPO.mono, marginTop: 2 }}>
                        {row.stavba || row.name || '(stavba nevyplnená)'} · {row.order_number || row.id}{row.date_issued ? ' · ' + row.date_issued : ''}
                      </div>
                      {(row.sent_at || Number(row.doc_version || 1) > 1) && (
                        <div style={{ fontSize: TYPO.sizes.xs, marginTop: 2 }}>
                          {Number(row.doc_version || 1) > 1 && <span style={{ color: COLORS.nav, fontWeight: TYPO.weights.semibold, marginRight: 6 }}>v{row.doc_version}</span>}
                          {row.sent_at
                            ? <span style={{ color: COLORS.add, fontWeight: TYPO.weights.semibold }}>E-mail {SK.datumCas(row.sent_at)}</span>
                            : <span style={{ color: COLORS.warn, fontWeight: TYPO.weights.semibold }}>Aktualizácia — neodoslaná</span>}
                        </div>
                      )}
                    </div>
                    <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: 4 }}>
                      <StatusTag status={row.status} />
                      <RowMenu actions={[
                        { key: 'edit',  label: 'Upraviť (základ)', onClick: () => setModal({ record: row }) },
                        { key: 'copy',  label: 'Duplikovať', icon: '⧉', onClick: async () => {
                          try {
                            const r = await fetchAuth(`/api/objednavky/${row.id}/copy`, { method: 'POST' })
                            const d = await r.json()
                            if (!r.ok) throw new Error(d.error || 'chyba')
                            toast.success('Duplikát objednávky vytvorený.')
                            load()
                          } catch (e) { toast.error('Duplikát sa nepodaril: ' + e.message) }
                        } },
                        { key: 'pdf',   label: 'Stiahnuť PDF', onClick: async () => {
                          try {
                            if (!(await pripravDokument(toast))) return   // p95
                            const r = await fetchAuth(`/api/orders/${row.id}/pdf`)
                            if (!r.ok) throw new Error('PDF zlyhalo')
                            const blob = await r.blob()
                            const url = URL.createObjectURL(blob)
                            const a = document.createElement('a')
                            a.href = url
                            a.download = `OBJ_${row.order_number || row.id}.pdf`
                            document.body.appendChild(a); a.click(); a.remove()
                            setTimeout(() => URL.revokeObjectURL(url), 1000)
                            toast.success('PDF stiahnuté')
                          } catch (e) { toast.error('Chyba: ' + e.message) }
                        } },
                        { key: 'preview', label: 'Náhľad PDF', onClick: async () => {
                          try {
                            if (!(await pripravDokument(toast))) return   // p95
                            const r = await fetchAuth(`/api/orders/${row.id}/pdf`)
                            if (!r.ok) throw new Error('PDF zlyhalo')
                            const blob = await r.blob()
                            const url = URL.createObjectURL(blob)
                            window.open(url, '_blank')
                          } catch (e) { toast.error('Chyba: ' + e.message) }
                        } },
                        { key: 'copy',  label: 'Vytvoriť kópiu',    onClick: async () => {
                          const ok = await confirm({
                            title: 'Vytvoriť kópiu objednávky?',
                            message: `Nová OBJ s dátumom dnes (na základe ${row.id}).`,
                            confirmLabel: 'Vytvoriť kópiu',
                          })
                          if (!ok) return
                          try {
                            const r = await fetchAuth(`/api/objednavky/${row.id}/copy`, { method: 'POST' })
                            const d = await r.json()
                            if (!r.ok) throw new Error(d.error || 'chyba')
                            toast.success(`Kópia vytvorená: ${d.id}`)
                            load()
                          } catch (e) { toast.error('Chyba: ' + e.message) }
                        } },
                        // Odoslanie PRIAMO z Matrixu (PDF príloha, ústava 67.14) — mailto zrušené (Apple Mail incident BD Pereš)
                        { key: 'email', label: row.sent_at ? 'Odoslať znova e-mailom' : 'Odoslať e-mailom', onClick: () => openSendMail(row) },
                        ...(row.sent_at ? [{ key: 'aktualizovat', label: 'Aktualizovať (nová verzia)', icon: '⟳', onClick: async () => {
                          const ok = await confirm({
                            title: 'Aktualizovať objednávku?',
                            message: `OBJ ${row.order_number || row.id} je po odoslaní uzamknutá. Vytvorí sa nová verzia v${Number(row.doc_version || 1) + 1} s rovnakým číslom — tú upravíš a znova odošleš. Odoslaná verzia ostane archivovaná.`,
                            confirmLabel: 'Vytvoriť novú verziu',
                          })
                          if (!ok) return
                          try {
                            const r = await fetchAuth(`/api/orders/${row.id}/aktualizovat`, { method: 'POST' })
                            const d = await r.json()
                            if (!r.ok) throw new Error(d.error || 'chyba')
                            toast.success(`Nová verzia v${d.version} vytvorená — uprav a odošli.`)
                            await load()
                            setSelectedId(d.id)
                          } catch (e) { toast.error('Chyba: ' + e.message) }
                        } }] : []),
                        { key: 'fa',    label: 'Vystaviť FA',       onClick: () => alert('Vystaviť FA — pripravujeme') },
                        { separator: true },
                        { key: 'del',   label: 'Vymazať',           danger: true, onClick: async () => {
                          const ok = await confirm({
                            title: 'Vymazať objednávku?',
                            message: `Naozaj zmazať OBJ ${row.id}${row.name ? ' (' + row.name + ')' : ''}? Zo zoznamu zmizne, z databázy sa nemaže — admin ju vie vrátiť v Logu aj s položkami.`,
                            danger: true, confirmLabel: 'Vymazať',
                          })
                          if (!ok) return
                          try {
                            // obj_maz_v1 (8. 10. 2026): server odteraz zamietne zmazanie tomu, kto naň nemá rolu —
                            // človek musí vidieť DÔVOD, nie „DELETE zlyhal".
                            const r = await fetchAuth(`/api/orders/${row.id}`, { method: 'DELETE' })
                            if (!r.ok) {
                              const d = await r.json().catch(() => ({}))
                              throw new Error(d.error || 'DELETE zlyhal')
                            }
                            toast.success('Odložené — vrátiť sa dá v Logu')
                            load()
                          } catch (e) { toast.error('Chyba: ' + e.message) }
                        } },
                      ]} />
                    </div>
                  </div>
                </ListRow>
              ))})()}
            </div>
            <ListStatusBar>
              ↑↓ výber · Enter detail · Alt+N nový · / hľadať · ⋮ Odoslať e-mailom = PDF z Matrixu, po odoslaní zámok
            </ListStatusBar>
          </>
        }
        right={
          selected
            ? <DetailPane record={selected} onEdit={() => setModal({ record: selected })} onSendMail={openSendMail} />
            : <EmptyPane text="Vyber záznam zo zoznamu vľavo" />
        }
      />

      {modal && (
        <RecordModal
          open
          record={modal.record}
          user={user}
          onClose={() => setModal(null)}
          onSaved={() => {
            setModal(null)
            load()
            toast.success('Uložené.')
          }}
        />
      )}

      {/* Náhľad e-mailu pred odoslaním OBJ (ústava 531 ConsequencePreview + 67.14) */}
      {mailFor && (
        <SendCustomerDialog open onClose={() => setMailFor(null)}
          title={`Odoslať OBJ ${mailFor.order_number || mailFor.id} e-mailom`}
          customerId={mailFor.partner_id || mailFor.customerId || ''}
          initTo={mailData.to} initCc={mailData.cc || ''} phone={mailData.phone || ''}
          initSubject={mailData.subject} initText={mailData.text}
          attachmentName={`OB_${String(mailFor.order_number || mailFor.id).replace(/[^a-zA-Z0-9_-]/g, '_')}.pdf`}
          attachmentNote="vygeneruje sa automaticky z aktuálneho stavu objednávky."
          footNote={'Po odoslaní sa objednávka uzamkne — úprava už len cez „Aktualizovať" (nová verzia, ktorá sa musí znova odoslať). Kópia e-mailu ostane v odoslanej pošte firemnej schránky.'}
          smsLabel="SMS, že mu bola odoslaná objednávka"
          smsText={'Dobry den, prave sme Vam poslali objednavku ' + (mailFor.order_number || mailFor.id) + ' na email. V pripade otazok volajte 0918 443 675. KAMIR'}
          smsEntityType={mailFor.project_id ? 'project' : ''} smsEntityId={mailFor.project_id || ''}
          onSend={async ({ to, cc, subject, text }) => {
            const x = await fetchAuth(`/api/orders/${mailFor.id}/send-email`, { method: 'POST', body: JSON.stringify({ email: to, cc, subject, text }) })
            const d = await x.json(); if (!x.ok) throw new Error(d.error || 'Odoslanie zlyhalo')
            toast.success('Objednávka je odteraz uzamknutá — úprava cez „Aktualizovať".')
            return { to: d.to }
          }}
          onSent={() => { setMailFor(null); load() }} />
      )}
    </div>
  )
}

// ══════════════════════════════════════════════════════════════════
// STATUS TAG — farebný štítok stavu (ústava 21.15 — z TINT, nie inline)
// ══════════════════════════════════════════════════════════════════
function StatusTag({ status }) {
  const isActive = status === 'active'
  return (
    <span style={{
      fontSize: TYPO.sizes.xs,
      fontWeight: TYPO.weights.semibold,
      color: isActive ? COLORS.add : COLORS.muted,
      background: isActive ? TINT.add : COLORS.lineSoft,
      borderRadius: RADIUS.sm,
      padding: '1px 7px',
    }}>{STATUS_LABEL[status] || status || '—'}</span>
  )
}

// ══════════════════════════════════════════════════════════════════
// DETAIL PANE — pravá strana, taby Detail / História (ústava sek. 56)
// ══════════════════════════════════════════════════════════════════
// === OBJ_FULL_EDITOR_v2 — plný editor objednávky (zhodný s CP) ===
// ── OrderVopPanel — Podmienky (VOP) ako v CP, + výber remesiel (Mirko 2026-06-25) ──
// Dáta: GET /api/orders/vop-items (order_vop_items, trade/section). Ukladá sa cez order.selected_trades + vop_override + vop_title.
function OrderVopPanel({ order, updField }) {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    fetchAuth('/api/orders/vop-items').then(r => r.ok ? r.json() : [])
      .then(d => { setItems(Array.isArray(d) ? d : []); setLoading(false) })
      .catch(() => setLoading(false))
  }, [])
  let selectedTrades; try { selectedTrades = JSON.parse(order.selected_trades || '["general"]') } catch { selectedTrades = ['general'] }
  if (!Array.isArray(selectedTrades)) selectedTrades = ['general']
  let override; try { override = JSON.parse(order.vop_override || '[]') } catch { override = [] }
  if (!Array.isArray(override)) override = []
  const isOff = (id) => { const o = override.find(x => x && typeof x === 'object' && x.id === id); return !!(o && o.enabled === false) }
  const TRADES = [
    { key: 'general',  label: 'Všeobecné podmienky', color: '#475569' },   // p94: dajú sa vypnúť (Mirko 21. 9. 2026)
    { key: 'spolocne', label: 'Stavebné práce',      color: '#1d4ed8' },
    { key: 'omietky',  label: 'Omietkarské práce',   color: '#b45309' },
    { key: 'potery',   label: 'Poterové práce',      color: '#065f46' },
  ]
  const toggleTrade = (t) => {
    let next = selectedTrades.includes(t) ? selectedTrades.filter(x => x !== t) : [...selectedTrades, t]
    updField('selected_trades', JSON.stringify(next))
  }
  const togglePoint = (id) => {
    const cleaned = override.filter(o => !(o && o.id === id))
    const next = isOff(id) ? cleaned : [...cleaned, { id, enabled: false }]
    updField('vop_override', JSON.stringify(next))
  }
  const byTrade = {}
  items.forEach(it => { const t = it.trade || 'general'; (byTrade[t] = byTrade[t] || []).push(it) })
  const titleStyle = { width: '100%', padding: '8px 10px', border: '1px solid ' + COLORS.line, borderRadius: RADIUS.sm, fontSize: TYPO.sizes.sm, fontFamily: 'inherit', boxSizing: 'border-box' }
  if (loading) return <div style={{ padding: SPACE.lg, color: COLORS.muted }}>Načítavam podmienky…</div>
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
      <div>
        <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4 }}>Názov podmienok (do PDF)</div>
        <input style={titleStyle} value={order.vop_title || ''} onChange={e => updField('vop_title', e.target.value)} placeholder="Dohodnuté podmienky výkonu práce" />
      </div>
      <div style={{ padding: SPACE.sm, background: COLORS.bgSoft, border: '1px solid ' + COLORS.line, borderRadius: RADIUS.sm, fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
        Vyber, ktoré podmienky idú do objednávky — aj <strong>Všeobecné</strong> sa dajú vypnúť. Jednotlivé body vypneš odškrtnutím — nepôjdu do PDF.
      </div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {TRADES.map(tr => {
          const on = tr.always || selectedTrades.includes(tr.key)
          return (
            <button key={tr.key} type="button" disabled={tr.always} onClick={() => !tr.always && toggleTrade(tr.key)} style={{
              padding: '7px 14px', borderRadius: RADIUS.sm, cursor: tr.always ? 'default' : 'pointer', fontFamily: 'inherit',
              fontSize: TYPO.sizes.sm, fontWeight: 700, border: '1.5px solid ' + (on ? tr.color : COLORS.line),
              background: on ? tr.color + '15' : '#fff', color: on ? tr.color : COLORS.muted,
            }}><span aria-hidden style={{ display: 'inline-block', width: 12, height: 12, border: '1.5px solid currentColor', borderRadius: 3, fontSize: 10, lineHeight: '10px', textAlign: 'center', verticalAlign: '-1px', marginRight: 5, boxSizing: 'content-box' }}>{on ? '✓' : ''}</span>{tr.label}{tr.always ? ' (vždy)' : ''}</button>
          )
        })}
      </div>
      {!TRADES.some(tr => selectedTrades.includes(tr.key)) && (
        <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted }}>Nie je vybraté nič — objednávka pôjde <strong>bez podmienok</strong> (v PDF nebude strana s podmienkami).</div>
      )}
      {TRADES.filter(tr => (tr.always || selectedTrades.includes(tr.key)) && (byTrade[tr.key] || []).length).map(tr => {
        const secs = {}
        byTrade[tr.key].forEach(it => { const k = (it.section_num || '') + '|' + (it.section_title || ''); (secs[k] = secs[k] || []).push(it) })
        return (
          <div key={tr.key} style={{ background: COLORS.bg, border: '1.5px solid ' + tr.color + '33', borderLeft: '4px solid ' + tr.color, borderRadius: RADIUS.md, overflow: 'hidden' }}>
            <div style={{ padding: '8px 12px', background: tr.color + '15', fontWeight: TYPO.weights.bold, color: tr.color, fontSize: TYPO.sizes.sm, textTransform: 'uppercase', letterSpacing: '0.06em' }}>{tr.label}</div>
            {Object.keys(secs).map(sk => {
              const parts = sk.split('|'); const snum = parts[0]; const stitle = parts[1]
              return (
                <div key={sk} style={{ padding: SPACE.sm, borderTop: '1px solid ' + COLORS.line }}>
                  {stitle ? <div style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: SPACE.xs }}>§{snum} {stitle}</div> : null}
                  {secs[sk].map((it, idx) => {
                    const off = isOff(it.id)
                    return (
                      <label key={it.id} style={{ display: 'flex', gap: SPACE.sm, alignItems: 'flex-start', padding: '4px', cursor: 'pointer', opacity: off ? 0.5 : 1 }}>
                        <input type="checkbox" checked={!off} onChange={() => togglePoint(it.id)} style={{ marginTop: 3 }} />
                        <span style={{ fontFamily: TYPO.mono, fontSize: TYPO.sizes.xs, color: tr.color, fontWeight: TYPO.weights.bold, minWidth: 20 }}>{idx + 1}.</span>
                        <span style={{ fontSize: TYPO.sizes.sm, textDecoration: off ? 'line-through' : 'none', flex: 1 }}>{it.text}</span>
                      </label>
                    )
                  })}
                </div>
              )
            })}
          </div>
        )
      })}
    </div>
  )
}

const CREATOR_ROLES = ['admin', 'owner', 'office_manager', 'owner_view', 'quotes_specialist']  // office/admin/majiteľ/predajňa (sek. Vytvoril)

function DetailPane({ record, onEdit, onSendMail }) {
  const [tab, setTab] = useState('editor')
  const [order, setOrder] = useState(record)
  const [items, setItems] = useState([])
  const [catalog, setCatalog] = useState([])
  const [customers, setCustomers] = useState([])
  const [projects, setProjects] = useState([])
  const [users, setUsers] = useState([])
  // podpis_funguje_v1: podpis sa vyberá zo ZOZNAMU ĽUDÍ, nie z napevno napísaných „Podpis 1/2".
  // Podpis je vec človeka a drží sa na jeho karte (ústava 0.J — jeden register).
  const [podpisovatelia, setPodpisovatelia] = useState([])
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [showPicker, setShowPicker] = useState(false)
  const [novyOpen, setNovyOpen] = useState(false)
  const [novyPrefill, setNovyPrefill] = useState('')
  // Zámok odoslaného dokumentu (ústava 67.14) — server vynucuje 423, UI len komunikuje
  const docLocked = !!(order.sent_at && !order.replaced_by)
  const toast = useToast()

  // p94b (Mirko 21. 9. 2026: „PDF stále generuje VOP“ — zmena na obrazovke nebola uložená a PDF sa robí z uloženej
  // objednávky). Náhľad PDF, PDF, Tlač a Odoslať e-mailom najprv uložia neuložené zmeny.
  const [ulozene, setUlozene] = useState(() => JSON.stringify(record))
  const neulozene = JSON.stringify(order) !== ulozene
  // p95: objednávka sa hlási do spoločného registra neuložených zmien (unsavedGuard) — okno Odoslať, PDF
  // a prechod na inú objednávku ju najprv uložia (ústava 67.15)
  // obj_blik_v1: zoznam závislostí — bez neho sa efekt spúšťal po KAŽDOM prekreslení obrazovky.
  // obj_text_v1 (6. 10. 2026): sleduje sa CELÝ `order`, nie len `neulozene`. To preskočí na true pri prvom znaku
  // a ďalej sa nemení, takže stráž by si držala uzáver so stavom spred písania a uložila by len prvé písmeno.
  useEffect(() => {
    const k = 'objednavka:' + order.id
    setGuardDirty(k, neulozene && !docLocked, () => saveHeader(true))
    return () => setGuardDirty(k, false)
  }, [order, neulozene, docLocked])
  useEffect(() => { setOrder(record); setUlozene(JSON.stringify(record)); reload() }, [record.id])

  // obj_blik_v1 (Mirko 6. 10. 2026 „všetko stále preblikuje“): ticho=true → obnoví LEN položky a NEPREPNE
  // obrazovku na „Načítavam…“. Používa sa po každej zmene položky; číselníky sa menia len pri otvorení dokladu.
  async function reload(ticho = false) {
    if (ticho) {
      try {
        const d = await fetchAuth(`/api/orders/${record.id}/items`).then(r => (r.ok ? r.json() : null))
        if (Array.isArray(d)) setItems(d)
      } catch (_) { /* tiché obnovenie nikdy nehlási chybu — zmena je už uložená na serveri */ }
      return
    }
    setLoading(true)
    try {
      const [linesData, catalogData, custData, projData, usersData] = await Promise.all([
        fetchAuth(`/api/orders/${record.id}/items`).then(r => r.ok ? r.json() : []),
        fetchAuth('/api/quote-catalog?active=1').then(r => r.ok ? r.json() : []),
        fetchAuth('/api/customers').then(r => r.ok ? r.json() : []),
        fetchAuth('/api/projects').then(r => r.ok ? r.json() : []),
        fetchAuth('/api/users').then(r => r.ok ? r.json() : []),
      ])
      setItems(Array.isArray(linesData) ? linesData : [])
      setCatalog(Array.isArray(catalogData) ? catalogData : [])
      setCustomers(Array.isArray(custData) ? custData : [])
      setProjects(Array.isArray(projData) ? projData : [])
      const allU = Array.isArray(usersData) ? usersData : (usersData && usersData.users) || []
      setUsers(allU.filter(u => (u.active == 1 || u.active === '1' || u.active === true) && CREATOR_ROLES.includes(u.role)))
    } catch (e) { toast.error('Chyba: ' + e.message) }
    finally { setLoading(false) }
  }

  useEffect(() => {
    fetchAuth('/api/employees')
      .then(r => r.ok ? r.json() : [])
      .then(d => setPodpisovatelia((Array.isArray(d) ? d : []).filter(z => z.podpis_file && z.active !== 0 && z.active !== '0')))
      .catch(() => setPodpisovatelia([]))
  }, [])

  // Staré objednávky majú 'podpis1'/'podpis2' — tie musia zostať vo výbere, inak by sa pri
  // otvorení starej objednávky výber tváril ako prázdny a uložením by sa podpis stratil.
  const podpisVolby = React.useMemo(() => {
    const v = [{ value: '', label: '— žiadny —' }]
    podpisovatelia.forEach(z => v.push({
      value: 'emp:' + z.id,
      label: [z.titul, z.name].filter(Boolean).join(' ') + (z.funkcia ? ' — ' + z.funkcia : ''),
    }))
    const sk = String(order.signature_key || '')
    if (/^podpis[0-9]+$/.test(sk)) v.push({ value: sk, label: sk === 'podpis1' ? 'Podpis 1 (Kašubjak) — starý' : sk + ' — starý' })
    return v
  }, [podpisovatelia, order.signature_key])

  function updField(k, v) { setOrder(prev => ({ ...prev, [k]: v })) }

  const pdfBlobUrl = async () => { const r = await fetchAuth(`/api/orders/${order.id}/pdf`); if (!r.ok) throw new Error('PDF zlyhalo'); return URL.createObjectURL(await r.blob()) }
  async function openPdf() { try { if (!(await ulozPredPdf())) return; window.open(await pdfBlobUrl(), '_blank') } catch (e) { toast.error('Chyba: ' + e.message) } }
  async function printPdf() { try { if (!(await ulozPredPdf())) return; const w = window.open(await pdfBlobUrl(), '_blank'); if (w) setTimeout(() => { try { w.print() } catch (_) {} }, 700) } catch (e) { toast.error('Chyba: ' + e.message) } }
  async function downloadPdf() { try { if (!(await ulozPredPdf())) return; const u = await pdfBlobUrl(); const a = document.createElement('a'); a.href = u; a.download = `OBJ_${order.order_number || order.id}.pdf`; document.body.appendChild(a); a.click(); a.remove(); setTimeout(() => URL.revokeObjectURL(u), 2000) } catch (e) { toast.error('Chyba: ' + e.message) } }
  async function saveHeader(predPdf) {
    const cb = (order.created_by || '').trim()
    if (!cb || cb.split(/\s+/).filter(Boolean).length < 2) {
      toast.error('Pole „Vytvoril" musí obsahovať Meno a Priezvisko')
      return false
    }
    setSaving(true)
    try {
      const r = await fetchAuth(`/api/orders/${order.id}`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(order),
      })
      if (!r.ok) throw new Error('save zlyhal')
      setUlozene(JSON.stringify(order))
      toast.success(predPdf === true ? 'Zmeny uložené — dokument je podľa obrazovky' : 'Hlavička uložená')
      return true
    } catch (e) { toast.error('Chyba: ' + e.message); return false }
    finally { setSaving(false) }
  }
  // Pred PDF, tlačou a odoslaním sa neuložené zmeny uložia; odoslaná (zamknutá) objednávka sa nemení.
  async function ulozPredPdf() { return await pripravDokument(toast) }   // p95: cez spoločný register (unsavedGuard)

  async function pickItem(item) {
    setShowPicker(false)
    try {
      const r = await fetchAuth(`/api/orders/${order.id}/items`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          catalog_item_id: item.id,
          name: item.title,
          full_name: item.full_name || '',
          description: item.description || '',
          unit: item.unit || 'm²',
          quantity: 0,
          price: item.price || 0,
          vat_pct: 0,
          labor_price: item.labor_price || 0,
          material_price: item.material_price || 0,
          material: item.material || '',
          thickness: item.thickness || '',
          consumption: item.consumption || '',
          image: item.image || '',
          price_mode: 'combined',
        }),
      })
      if (!r.ok) throw new Error('add')
      toast.success(`+ ${item.title}`)
      reload(true)   // obj_blik_v1: tiché obnovenie, bez preblikania
    } catch (e) { toast.error('Chyba: ' + e.message) }
  }

  async function addFreeItem() {
    try {
      const r = await fetchAuth(`/api/orders/${order.id}/items`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: '', unit: 'ks', quantity: 0, price: 0, vat_pct: 0, price_mode: 'combined' }),
      })
      if (!r.ok) throw new Error('add')
      toast.success('Pridaná vlastná položka — vyplň popis vľavo')
      reload(true)   // obj_blik_v1: tiché obnovenie, bez preblikania
    } catch (e) { toast.error('Chyba: ' + e.message) }
  }
  async function setAllDph(pct) {
    try {
      await Promise.all(items.map(it => fetchAuth(`/api/orders/${order.id}/items/${it.id}`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...it, vat_pct: pct }),
      })))
      toast.success(pct > 0 ? `DPH ${pct}% zapnuté` : 'DPH vypnuté (0%)')
      reload(true)   // obj_blik_v1: tiché obnovenie, bez preblikania
    } catch (e) { toast.error('Chyba: ' + e.message) }
  }
  async function updateItem(it, changes) {
    try {
      const r = await fetchAuth(`/api/orders/${order.id}/items/${it.id}`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...it, ...changes }),
      })
      if (!r.ok) throw new Error('update')
      reload(true)   // obj_blik_v1: tiché obnovenie, bez preblikania
    } catch (e) { toast.error('Chyba: ' + e.message) }
  }

  async function deleteItem(it) {
    if (!confirm(`Odstrániť riadok "${it.name}"?`)) return
    try {
      await fetchAuth(`/api/orders/${order.id}/items/${it.id}`, { method: 'DELETE' })
      toast.error('Riadok odstránený')
      reload(true)   // obj_blik_v1: tiché obnovenie, bez preblikania
    } catch (e) { toast.error('Chyba: ' + e.message) }
  }

  async function moveItem(it, dir) {
    try {
      const r = await fetchAuth(`/api/orders/${order.id}/items/${it.id}/move`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ dir }),
      })
      if (!r.ok) throw new Error('presun zlyhal')
      reload(true)   // obj_blik_v1: tiché obnovenie, bez preblikania
    } catch (e) { toast.error('Chyba: ' + e.message) }
  }

  const subTotal = items.reduce((s, l) => s + (Number(l.quantity) || 0) * (Number(l.price) || 0), 0)
  const vatRate = items.length > 0 ? (Number(items[0].vat_pct) || 0) : 0
  const vatAmt = subTotal * (vatRate / 100)
  const total = subTotal + vatAmt

  return (
    <div style={{
      background: COLORS.bgSoft, border: `1px solid ${COLORS.line}`,
      borderRadius: RADIUS.lg, height: '100%',
      display: 'flex', flexDirection: 'column', overflow: 'hidden',
    }}>
      {/* HLAVIČKA KARTY — tenký stavový pásik + čierny názov (ústava 61.6) */}
      {/* HLAVIČKA */}
      <div style={{ height: 4, background: COLORS.brand }} />
      <NoviCustomerDialog open={novyOpen} prefillName={novyPrefill} onClose={() => setNovyOpen(false)} onCreated={c => { setCustomers(prev => [...prev, c]); updField('partner_id', c.id); setNovyOpen(false) }} />
      <div style={{
        display: 'flex', alignItems: 'center', gap: SPACE.md,
        padding: `${SPACE.sm}px ${SPACE.lg}px`,
        borderBottom: `1px solid ${COLORS.line}`,
        background: COLORS.bg,
      }}>
        <h2 style={{ margin: 0, fontSize: TYPO.sizes.lg, fontWeight: TYPO.weights.extra,
          color: COLORS.brandText }}>
          {order.order_number || order.id} · {order.stavba || order.name || '(bez stavby)'}
        </h2>
        <StatusTag status={order.status} />
        <HelpHint text="ČO: objednávku odošleš partnerovi cez ⋮ pri riadku → Odoslať e-mailom (PDF príloha sa vygeneruje automaticky). PREČO: odoslaná objednávka sa uzamkne — vždy dohľadáš, čo presne partner dostal; zmeniť smieš už len stav a interné poznámky. KAM: kópia e-mailu ostane v odoslanej pošte firemnej schránky; úprava = ⋮ Aktualizovať (nová verzia s rovnakým číslom, ktorú znova odošleš). Podrobne: manuál → Odosielanie ponúk a objednávok." />
        {Number(order.doc_version || 1) > 1 && (
          <span style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, color: COLORS.nav, background: TINT.nav, borderRadius: RADIUS.sm, padding: '1px 7px' }}>verzia {order.doc_version}</span>
        )}
        <div style={{ flex: 1 }} />
        <BtnGhost onClick={openPdf}>Náhľad PDF</BtnGhost>
        {onSendMail && <BtnGhost onClick={async () => { if (await ulozPredPdf()) onSendMail(order) }}>Odoslať e-mailom</BtnGhost>}
        <BtnGhost onClick={printPdf}>Tlač</BtnGhost>
        <BtnGhost onClick={downloadPdf}>PDF</BtnGhost>
        <BtnAdd onClick={() => saveHeader()} disabled={saving || docLocked} title={neulozene ? 'Na obrazovke sú neuložené zmeny — pred PDF a odoslaním sa uložia samy' : ''}>{saving ? 'Ukladám…' : (neulozene ? '✓ Uložiť zmeny' : '✓ Uložiť')}</BtnAdd>
      </div>

      {/* Zámok odoslaného dokumentu (ústava 67.14) */}
      {docLocked && (
        <div style={{ padding: `${SPACE.sm}px ${SPACE.lg}px`, background: TINT.add, borderBottom: `1px solid ${COLORS.line}`, fontSize: TYPO.sizes.sm, color: COLORS.text }}>
          <strong style={{ color: COLORS.add }}>Odoslané {SK.datumCas(order.sent_at)}</strong>
          {order.sent_to ? <> na <strong>{order.sent_to}</strong></> : null} — obsah je uzamknutý presne tak, ako odišiel.
          Na úpravu použi <strong>„Aktualizovať (nová verzia)"</strong> v menu ⋮ pri riadku v zozname.
        </div>
      )}

      <Tabs value={tab} onChange={setTab} tabs={[
        { key: 'editor',  label: 'Editor' },
        { key: 'vop',     label: 'Podmienky' },
        { key: 'history', label: 'História' },
      ]} />

      <div style={{ padding: SPACE.md, overflow: 'auto', flex: 1 }}>
        {tab === 'editor' && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
            {/* Hlavičkové polia */}
            <div style={{
              padding: SPACE.md, background: COLORS.bg,
              border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md,
              display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: SPACE.sm,
            }}>
              <FieldOBJ label="Zákazník">
                <div style={{ display: 'flex', gap: 6 }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <SearchableSelect value={order.partner_id || ''}
                      onChange={v => { /* prefill kontaktu z partnera */
                        updField('partner_id', v)
                        const c = customers.find(x => x.id === v)
                        if (c) {
                          if (c.contact) updField('contact_person', c.contact)
                          if (c.phone) updField('contact_phone', c.phone)
                          if (c.email) updField('contact_email', c.email)
                        }
                      }}
                      options={customers.map(c => ({ value: c.id, label: `${c.name} (${c.id})` }))}
                      placeholder="Hľadať podľa mena alebo IČO…" />
                  </div>
                  <button type="button" onClick={() => { setNovyPrefill(''); setNovyOpen(true) }} style={{ padding: '0 12px', border: `1px solid ${COLORS.brand}`, background: COLORS.bg, color: COLORS.brand, borderRadius: RADIUS.sm, cursor: 'pointer', fontWeight: 700, fontSize: TYPO.sizes.sm, fontFamily: 'inherit', whiteSpace: 'nowrap' }}title="Nový zákazník — vyhľadanie v ORSR/VIES">+ Nový</button>
                </div>
              </FieldOBJ>
              <FieldOBJ label="Stavba / Projekt (zákazka)">
                <SearchableSelect value={order.project_id || ''}
                  onChange={v => { updField('project_id', v); const p = projects.find(x => x.id === v); if (p) updField('stavba', p.name) }}
                  options={projects.map(p => ({ value: p.id, label: `${p.name} (${p.id})${p.status && p.status !== 'active' ? ' · ' + p.status : ''}` }))}
                  placeholder="— vyber zákazku (aj neaktívnu) —" />
              </FieldOBJ>
              <FieldOBJ label="Číslo OBJ">
                <input style={inpOBJ} value={order.order_number || order.id || ''} disabled />
              </FieldOBJ>
              <FieldOBJ label="Dátum vystavenia">
                <input style={inpOBJ} type="date" value={order.date_issued || ''}
                  onChange={e => updField('date_issued', e.target.value)} />
              </FieldOBJ>
              <FieldOBJ label="Platnosť do">
                <input style={inpOBJ} type="date" value={order.valid_until || ''}
                  title="Dokedy objednávka platí. Prázdne = 14 dní od vystavenia."
                  onChange={e => updField('valid_until', e.target.value)} />
                <div style={{ display: 'flex', gap: 5, marginTop: 4, flexWrap: 'wrap' }}>
                  {(() => {
                    const zaklad = order.date_issued || todayLocal()
                    const posun = (dni) => new Date(new Date(zaklad).getTime() + dni * 86400000).toISOString().slice(0, 10)
                    const koniecRoka = String(new Date(zaklad).getFullYear() || new Date().getFullYear()) + '-12-31'
                    const btn = { padding: '2px 7px', fontSize: TYPO.sizes.xs, border: `1px solid ${COLORS.line}`,
                      background: '#fff', color: COLORS.muted, borderRadius: RADIUS.sm, cursor: 'pointer', fontFamily: 'inherit' }
                    return [
                      ['+14 dní', posun(14)], ['+30 dní', posun(30)], ['do konca roka', koniecRoka],
                    ].map(([lbl, val]) => (
                      <button key={lbl} type="button" style={btn} onClick={() => updField('valid_until', val)}>{lbl}</button>
                    ))
                  })()}
                </div>
              </FieldOBJ>
              <FieldOBJ label="Dátum dodania">
                <input style={inpOBJ} type="date" value={order.date_delivery || ''}
                  title="Dokedy má byť dodané. Tlačí sa na objednávku."
                  onChange={e => updField('date_delivery', e.target.value)} />
              </FieldOBJ>
              <FieldOBJ label="Stav">
                <select style={inpOBJ} value={order.status || 'draft'}
                  onChange={e => updField('status', e.target.value)}>
                  {Object.entries(STATUS_LABEL).map(([k, v]) => (<option key={k} value={k}>{v}</option>))}
                </select>
              </FieldOBJ>
              <FieldOBJ label="Vytvoril *">
                <SearchableSelect value={order.created_by || ''}
                  onChange={v => updField('created_by', v)}
                  options={users.map(u => { const nm = (u.display_name || u.username).replace(/\s*\(.*\)\s*$/, '').trim(); return ({ value: nm, label: nm }) })}
                  placeholder="— vyber (Meno Priezvisko) —" />
              </FieldOBJ>
              <FieldOBJ label="Podpis">
                <SearchableSelect value={order.signature_key || ''}
                  onChange={v => updField('signature_key', v)}
                  options={podpisVolby}
                  placeholder="— žiadny —" />
              </FieldOBJ>
              {/* ústava 131.10 + 0.J (p93): JEDEN blok kontaktnej osoby v celom Matrixe — osoba z registra partnera */}
              <KontaktnaOsoba customerId={order.partner_id || order.customerId} inp={inpOBJ}
                osoba={{ meno: order.contact_person, telefon: order.contact_phone, email: order.contact_email }}
                onZmena={o => { updField('contact_person', o.meno); updField('contact_phone', o.telefon); updField('contact_email', o.email) }}
                popisy={{ osoba: 'Kontaktná osoba zákazníka' }}
                obal={(tx, pole, kl) => <FieldOBJ key={kl} label={tx}>{pole}</FieldOBJ>} />
            </div>

            {/* Text objednávky (full-width) — Mirko 22.7.: predvyplnené z CP „…podľa CP <číslo> a VOP uvedených v CP." */}
            <div style={{ marginTop: SPACE.md }}>
              <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.03em' }}>Text objednávky (položky)</div>
              <textarea style={{ ...inpOBJ, resize: 'vertical', minHeight: 64, width: '100%', boxSizing: 'border-box' }}
                value={order.body_text || ''}
                onChange={e => updField('body_text', e.target.value)}
                placeholder="Objednávka na dodávku a montáž materiálov podľa CP … a VOP uvedených v CP." />
            </div>

            {/* Položky */}
            <div style={{
              background: COLORS.bg, border: `1px solid ${COLORS.line}`,
              borderRadius: RADIUS.md, overflow: 'hidden',
            }}>
              <div style={{
                padding: `${SPACE.sm}px ${SPACE.md}px`,
                background: COLORS.bgSoft, borderBottom: `1px solid ${COLORS.line}`,
                display: 'flex', alignItems: 'center', gap: SPACE.sm,
              }}>
                <strong>Položky objednávky ({items.length})</strong>
                <div style={{ flex: 1 }} />
                <BtnGhost onClick={addFreeItem}>+ Vlastná položka</BtnGhost>
                <BtnAdd onClick={() => setShowPicker(true)}>+ Pridať z katalógu</BtnAdd>
              </div>

              {loading ? (
                <div style={{ padding: SPACE.lg, color: COLORS.muted, textAlign: 'center' }}>Načítavam…</div>
              ) : items.length === 0 ? (
                <div style={{ padding: SPACE.lg, color: COLORS.muted, textAlign: 'center' }}>
                  Žiadne položky. Klikni „+ Pridať z katalógu".
                </div>
              ) : (
                <div>
                  <div style={{
                    display: 'grid', gridTemplateColumns: '84px 1fr 100px 60px 100px 100px 60px',
                    gap: 4, padding: '6px 12px',
                    background: COLORS.bgSoft, borderBottom: `1px solid ${COLORS.line}`,
                    fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold,
                    color: COLORS.muted, textTransform: 'uppercase',
                  }}>
                    <div>Foto</div>
                    <div>Položka</div>
                    <div style={{ textAlign: 'right' }}>Množstvo</div>
                    <div style={{ textAlign: 'center' }}>MJ</div>
                    <div style={{ textAlign: 'right' }}>Cena/MJ</div>
                    <div style={{ textAlign: 'right' }}>Spolu</div>
                    <div></div>
                  </div>
                  {items.map((it, idx) => (
                    <ItemRowOBJ key={it.id} item={it} idx={idx} count={items.length} catalog={catalog}
                      onUpdate={updateItem} onDelete={deleteItem} onMove={moveItem} />
                  ))}
                </div>
              )}

              {items.length > 0 && (
                <div style={{
                  padding: SPACE.md, borderTop: `2px solid ${COLORS.line}`,
                  background: COLORS.bgSoft,
                  display: 'flex', justifyContent: 'flex-end', gap: SPACE.xl,
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginRight: 'auto' }}>
                    <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontWeight: 700 }}>DPH:</span>
                    {[0, 20].map(p => (
                      <button key={p} type="button" onClick={() => setAllDph(p)} style={{
                        padding: '4px 10px', borderRadius: RADIUS.sm, cursor: 'pointer', fontFamily: 'inherit',
                        fontSize: TYPO.sizes.xs, fontWeight: 700,
                        border: `1.5px solid ${vatRate === p ? COLORS.brand : COLORS.line}`,
                        background: vatRate === p ? COLORS.brand : '#fff', color: vatRate === p ? '#fff' : COLORS.muted,
                      }}>{p}%</button>
                    ))}
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Bez DPH</div>
                    <div style={{ fontFamily: TYPO.mono, fontWeight: TYPO.weights.semibold }}>{SK.eur(subTotal)}</div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>DPH {vatRate}%</div>
                    <div style={{ fontFamily: TYPO.mono, color: COLORS.total }}>+{SK.eur(vatAmt)}</div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Spolu s DPH</div>
                    <div style={{ fontFamily: TYPO.mono, fontSize: TYPO.sizes.lg,
                      fontWeight: TYPO.weights.bold, color: COLORS.brandText }}>{SK.eur(total)}</div>
                  </div>
                </div>
              )}
            </div>

            <FieldOBJ label="Poznámka — interná, v PDF objednávky sa nezobrazuje">
              <textarea style={{ ...inpOBJ, resize: 'vertical', minHeight: 60 }}
                value={order.notes || ''}
                onChange={e => updField('notes', e.target.value)} />
            </FieldOBJ>
          </div>
        )}

        {tab === 'vop' && (
          <OrderVopPanel order={order} updField={updField} />
        )}
        {tab === 'history' && (
          <HistoryPanel module={CFG.resource} entityId={record.id} />
        )}
      </div>

      {showPicker && (
        <CatalogPickerOBJ catalog={catalog} onPick={pickItem} onClose={() => setShowPicker(false)} />
      )}
    </div>
  )
}

const inpOBJ = {
  width: '100%', padding: '7px 10px',
  border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm,
  fontSize: TYPO.sizes.sm, background: COLORS.bg,
  fontFamily: 'inherit', boxSizing: 'border-box',
}

function FieldOBJ({ label, children }) {
  return (
    <label>
      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 3,
        fontWeight: TYPO.weights.semibold, textTransform: 'uppercase', letterSpacing: '0.04em' }}>{label}</div>
      {children}
    </label>
  )
}

// Šípky poradia položky — vľavo pri obrázku (Mirko 2026-07-14); line-ikony, žiadne emoji (ústava)
function MoveArrows({ canUp, canDown, onMove }) {
  const b = (dis) => ({ width: 20, height: 16, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff', border: `1px solid ${COLORS.line}`, borderRadius: 4, cursor: dis ? 'default' : 'pointer', opacity: dis ? 0.25 : 1, color: COLORS.muted })
  const Ch = ({ up }) => <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">{up ? <path d="m18 15-6-6-6 6" /> : <path d="m6 9 6 6 6-6" />}</svg>
  return (
    <span style={{ display: 'inline-flex', flexDirection: 'column', gap: 2, marginRight: 4, flexShrink: 0 }}>
      <button type="button" disabled={!canUp} onClick={() => canUp && onMove('up')} title="Posunúť vyššie" style={b(!canUp)}><Ch up /></button>
      <button type="button" disabled={!canDown} onClick={() => canDown && onMove('down')} title="Posunúť nižšie" style={b(!canDown)}><Ch /></button>
    </span>
  )
}

function ItemRowOBJ({ item, idx, count, catalog, onUpdate, onDelete, onMove }) {
  const [qty, setQty] = useState(item.quantity || 0)
  const [price, setPrice] = useState(item.price || 0)
  const [name, setName] = useState(item.name || '')
  const [unit, setUnit] = useState(item.unit || '')
  useEffect(() => { setQty(item.quantity || 0); setPrice(item.price || 0); setName(item.name || ''); setUnit(item.unit || '') }, [item.id])
  const total = (Number(qty) || 0) * (Number(price) || 0)
  return (
    <div style={{
      display: 'grid', gridTemplateColumns: '84px 1fr 100px 60px 100px 100px 60px',
      gap: 4, padding: '6px 12px',
      borderBottom: `1px solid ${COLORS.lineSoft || COLORS.line}`,
      background: idx % 2 ? COLORS.bgSoft : 'transparent',
      alignItems: 'center', fontSize: TYPO.sizes.sm,
    }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <MoveArrows canUp={idx > 0} canDown={idx < count - 1} onMove={(dir) => onMove(item, dir)} />
        {item.image
          ? <img src={`/uploads/${item.image}`} alt="" style={{
              width: 44, height: 44, objectFit: 'cover',
              borderRadius: RADIUS.sm, border: `1px solid ${COLORS.line}` }} />
          : <div style={{ width: 44, height: 44, background: COLORS.bgSoft,
              border: `1px dashed ${COLORS.line}`, borderRadius: RADIUS.sm,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 16, color: COLORS.muted }}></div>}
      </div>
      <div>
        <input style={{ ...inpOBJ, padding: '4px 6px', fontWeight: TYPO.weights.semibold, width: '100%' }}
          value={name} onChange={e => setName(e.target.value)}
          onBlur={() => { if (name !== item.name) onUpdate(item, { name }) }}
          placeholder="Popis práce / položky…" />
        {item.material && (
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontStyle: 'italic' }}>{item.material}</div>
        )}
      </div>
      <div>
        <input style={{ ...inpOBJ, padding: '4px 6px', textAlign: 'right', fontFamily: TYPO.mono }}
          type="number" step="0.01" value={qty}
          onChange={e => setQty(e.target.value)}
          onBlur={() => { if (Number(qty) !== item.quantity) onUpdate(item, { quantity: Number(qty) || 0 }) }} />
      </div>
      <div>
        <input style={{ ...inpOBJ, padding: '4px 4px', textAlign: 'center', fontSize: TYPO.sizes.xs }}
          value={unit} onChange={e => setUnit(e.target.value)}
          onBlur={() => { if (unit !== item.unit) onUpdate(item, { unit }) }} placeholder="MJ" />
      </div>
      <div>
        <input style={{ ...inpOBJ, padding: '4px 6px', textAlign: 'right', fontFamily: TYPO.mono }}
          type="number" step="0.01" value={price}
          onChange={e => setPrice(e.target.value)}
          onBlur={() => { if (Number(price) !== item.price) onUpdate(item, { price: Number(price) || 0 }) }} />
      </div>
      <div style={{ textAlign: 'right', fontFamily: TYPO.mono, fontWeight: TYPO.weights.bold }}>{SK.eur(total)}</div>
      <div style={{ textAlign: 'center' }}>
        <button onClick={() => onDelete(item)}
          style={{ background: 'transparent', border: 'none', cursor: 'pointer',
            color: COLORS.remove, fontSize: 16, padding: 4 }}>✕</button>
      </div>
    </div>
  )
}

function CatalogPickerOBJ({ catalog, onPick, onClose }) {
  const [search, setSearch] = useState('')
  const filtered = catalog.filter(c => {
    if (!search.trim()) return true
    const q = search.toLowerCase()
    return hladaj((c.title || ''), q) || hladaj((c.material || ''), q)
  })
  return (
    <Modal open title="Vyber položku z katalógu" onClose={onClose} width={900}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md, maxHeight: '70vh' }}>
        <input style={{ ...inpOBJ }} value={search} onChange={e => setSearch(e.target.value)}
          placeholder="Hľadať položku…" autoFocus />
        <div style={{ overflow: 'auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.sm }}>
          {filtered.map(c => (
            <div key={c.id} onClick={() => onPick(c)} style={{
              padding: SPACE.sm, background: COLORS.bg,
              border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm,
              display: 'flex', gap: SPACE.sm, cursor: 'pointer',
            }}
              onMouseEnter={e => e.currentTarget.style.background = COLORS.bgSoft}
              onMouseLeave={e => e.currentTarget.style.background = COLORS.bg}>
              {c.image
                ? <img src={`/uploads/${c.image}`} alt="" style={{ width: 56, height: 56, objectFit: 'cover', borderRadius: RADIUS.sm }} />
                : <div style={{ width: 56, height: 56, background: COLORS.bgSoft,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    borderRadius: RADIUS.sm, fontSize: 22 }}></div>}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: TYPO.weights.semibold, fontSize: TYPO.sizes.sm,
                  whiteSpace: 'normal', wordBreak: 'break-word' }}>{c.title}</div>
                <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontStyle: 'italic',
                  whiteSpace: 'normal', wordBreak: 'break-word' }}>{c.material || ''}</div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 4, fontSize: TYPO.sizes.xs }}>
                  <span style={{ color: COLORS.muted }}>{c.unit}</span>
                  <span style={{ fontFamily: TYPO.mono, fontWeight: TYPO.weights.bold }}>{SK.eur(c.price)}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  )
}


// ══════════════════════════════════════════════════════════════════
// RECORD MODAL — edit / new cez useRecordEditor (S1)
// Lock + dirty + Form→Confirm + DIFF — všetko zabudované v hooku.
// ══════════════════════════════════════════════════════════════════
function RecordModal({ open, record, user, onClose, onSaved }) {
  const isNew = !record

  const ed = useRecordEditor({
    resource: CFG.resource,
    id: record?.id || null,
    user,
    initial: {
      order_number: record?.order_number || '',
      type:         record?.type         || 'sent',
      status:       record?.status       || 'draft',
      partner_id:   record?.partner_id   || '',
      project_id:   record?.project_id   || '',
      notes:        record?.notes        || '',
    },
    fields: EDIT_FIELDS,
    onSubmit: async (values) => {
      const r = await fetchAuth(
        isNew ? CFG.apiBase : `${CFG.apiBase}/${record.id}`,
        { method: isNew ? 'POST' : 'PUT', body: JSON.stringify(values) }
      )
      if (!r.ok) {
        const d = await r.json().catch(() => ({}))
        // dedup (ústava sek. 13) — backend vracia 409 pri duplicite
        if (r.status === 409) throw new Error(d.message || 'Taký záznam už existuje.')
        throw new Error(d.error || 'Uloženie zlyhalo.')
      }
    },
  })

  if (!open) return null

  const doClose = () => ed.requestClose(onClose)

  const validate = (v) => {
    if (!v.name || !v.name.trim()) return 'Názov je povinný.'
    return null
  }

  const handleConfirm = async () => {
    const ok = await ed.submit()
    if (ok) onSaved()
  }

  const readOnly = !ed.canEdit

  return (
    <>
      <Modal
        open
        onClose={doClose}
        onDirtyClose={doClose}
        isDirty={ed.isDirty}
        title={isNew ? CFG.newLabel : `Upraviť — ${record.name}`}
        subtitle={ed.phase === 'confirm' ? 'Skontroluj zmeny pred uložením' : ''}
        maxWidth={640}
        footer={
          ed.phase === 'form' ? (
            <>
              <BtnGhost onClick={doClose}>Zrušiť</BtnGhost>
              <BtnAdd onClick={() => ed.goConfirm(validate)} disabled={readOnly}>
                Uložiť →
              </BtnAdd>
            </>
          ) : (
            <>
              <BtnGhost onClick={ed.back}>← Späť na úpravu</BtnGhost>
              <BtnAdd onClick={handleConfirm} disabled={ed.submitting}>
                {ed.submitting ? 'Ukladám…' : '✓ Potvrdiť uloženie'}
              </BtnAdd>
            </>
          )
        }
      >
        {/* LOCK banner — záznam upravuje niekto iný (ústava 53.7) */}
        {readOnly && ed.lockedBy && (
          <div style={{
            background: TINT.remove,
            border: `1px solid ${COLORS.remove}`,
            borderRadius: RADIUS.md,
            padding: SPACE.sm,
            marginBottom: SPACE.md,
            fontSize: TYPO.sizes.sm,
            color: COLORS.remove,
          }}>
            Záznam práve upravuje <strong>{ed.lockedBy}</strong>. Editácia je zamknutá.
          </div>
        )}

        {ed.error && (
          <div style={{
            background: TINT.remove,
            border: `1px solid ${COLORS.remove}`,
            borderRadius: RADIUS.md,
            padding: SPACE.sm,
            marginBottom: SPACE.md,
            fontSize: TYPO.sizes.sm,
            color: COLORS.remove,
          }}>{ed.error}</div>
        )}

        {ed.phase === 'form' ? (
          // ── FORM fáza ──────────────────────────────────────────────
          <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
            <div style={{ padding: SPACE.md, background: 'rgba(59,130,246,0.06)',
              border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md,
              fontSize: TYPO.sizes.sm, color: COLORS.nav }}>
              V2 zobrazuje len základné polia. Po uložení použi v menu riadku <strong>„Upraviť plne (Matrix 1)"</strong>
              pre položky, VOP a prílohy — alebo rovno <strong>otvoriť starý Matrix</strong>:
              <a href={`http://${window.location.hostname}:8090/objednavky`} target="_blank" rel="noreferrer"
                 style={{ marginLeft: 6, color: COLORS.nav, fontWeight: 600 }}>8090/objednavky →</a>
              <br/>Pre <strong>PDF</strong> klikni „Stiahnuť PDF" alebo „Náhľad PDF" v menu — pracuje natívne v V2.
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.md }}>
              <Field label="Číslo OBJ">
                <input type="text" value={ed.values.order_number} disabled={readOnly}
                  onChange={e => ed.set('order_number', e.target.value)} style={inputStyle} />
              </Field>
              <Field label="Typ">
                <SearchableSelect value={ed.values.type} onChange={v => ed.set('type', v)}
                  options={[
                    { value: 'sent',     label: 'Odoslaná (my objednávame)' },
                    { value: 'received', label: 'Prijatá (nám objednali)' },
                  ]} />
              </Field>
            </div>
            <Field label="Stav">
              <SearchableSelect value={ed.values.status} onChange={v => ed.set('status', v)}
                options={[
                  { value: 'draft',     label: 'Pracovná' },
                  { value: 'sent',      label: 'Odoslaná' },
                  { value: 'confirmed', label: 'Potvrdená' },
                  { value: 'cancelled', label: 'Zrušená' },
                ]} />
            </Field>
            <Field label="Partner (ID)">
              <input type="text" value={ed.values.partner_id} disabled={readOnly}
                onChange={e => ed.set('partner_id', e.target.value)} style={inputStyle} />
            </Field>
            <Field label="Zákazka (ID)">
              <input type="text" value={ed.values.project_id} disabled={readOnly}
                onChange={e => ed.set('project_id', e.target.value)} style={inputStyle} />
            </Field>
            <Field label="Poznámka — interná, v PDF objednávky sa nezobrazuje">
              <textarea value={ed.values.notes} disabled={readOnly}
                onChange={e => ed.set('notes', e.target.value)} rows={3}
                style={{ ...inputStyle, resize: 'vertical' }} />
            </Field>
          </div>
        ) : (
          // ── CONFIRM fáza — DIFF prehľad (ústava 53.8) ───────────────
          <div>
            {isNew ? (
              <p style={{ fontSize: TYPO.sizes.base, color: COLORS.text }}>
                Vytvorí sa nový záznam <strong>{ed.values.name}</strong>.
              </p>
            ) : ed.diff.length === 0 ? (
              <p style={{ color: COLORS.muted }}>Žiadne zmeny.</p>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
                <thead>
                  <tr style={{ background: TINT.nav }}>
                    <th style={thStyle}>Pole</th>
                    <th style={thStyle}>Pôvodné</th>
                    <th style={thStyle}>Nové</th>
                  </tr>
                </thead>
                <tbody>
                  {ed.diff.map(d => (
                    <tr key={d.name}>
                      <td style={tdStyle}>{d.label}</td>
                      <td style={{ ...tdStyle, color: COLORS.muted, textDecoration: 'line-through' }}>
                        {d.from}
                      </td>
                      <td style={{ ...tdStyle, color: COLORS.add, fontWeight: TYPO.weights.semibold }}>
                        {d.to}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </Modal>

      {/* DIRTY dialóg — Uložiť / Pokračovať / Zahodiť (ústava 53.1) */}
      <Modal.DirtyConfirm {...ed.dirtyProps} />
    </>
  )
}

function Field({ label, children }) {
  return (
    <label style={{ display: 'block' }}>
      <div style={{
        fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold,
        color: COLORS.muted, marginBottom: 4, textTransform: 'uppercase',
        letterSpacing: '0.04em',
      }}>{label}</div>
      {children}
    </label>
  )
}

const inputStyle = {
  width: '100%',
  padding: '6px 10px',
  fontSize: TYPO.sizes.base,
  fontFamily: 'inherit',
  border: `1px solid ${COLORS.line}`,
  borderRadius: RADIUS.md,
  outline: 'none',
  boxSizing: 'border-box',
}
const thStyle = {
  textAlign: 'left', padding: '6px 10px',
  fontSize: TYPO.sizes.xs, color: COLORS.nav,
  textTransform: 'uppercase', letterSpacing: '0.04em',
  borderBottom: `1px solid ${COLORS.line}`,
}
const tdStyle = {
  padding: '6px 10px',
  borderBottom: `1px solid ${COLORS.lineSoft}`,
}

// ╔══════════════════════════════════════════════════════════════════╗
// ║  DoD CHECKLIST — skopíruj do HANDOFF, odškrtni pred dokončením    ║
// ║  (ústava 9.D.1 bod 3). Modul NIE JE hotový kým nie sú všetky ✅.  ║
// ╠══════════════════════════════════════════════════════════════════╣
// ║  [ ] CFG vyplnené (resource, apiBase, labels)                    ║
// ║  [ ] EDIT_FIELDS = všetky editovateľné polia (kvôli DIFF)        ║
// ║  [ ] LOCK funguje — test 2 okná naraz (53.7)                     ║
// ║  [ ] DIRTY dialóg pri zatvorení s neuloženými zmenami (53.1)     ║
// ║  [ ] Form → Confirm + DIFF pred uložením (12.0/3, 53.8)         ║
// ║  [ ] HistoryPanel ukazuje audit záznamu (12.0/1)                 ║
// ║  [ ] hľadanie v zozname funguje (56)                             ║
// ║  [ ] žiadny plain <select> — len SearchableSelect (56.11)        ║
// ║  [ ] žiadne inline farby pozadia — len TINT/tint() (21.15)       ║
// ║  [ ] dedup — backend vracia 409 pri duplicite (13)               ║
// ║  [ ] mod+N a / skratky + cheatsheet (54)                         ║
// ║  [ ] starý modul porovnaný — všetky polia/funkcie prenesené      ║
// ║  [ ] ÚSTAVA-REVIEW — druhý prechod kódu bod po bode (9.D.3)      ║
// ╚══════════════════════════════════════════════════════════════════╝
